<template>
    <li>
        <download-link :href="url" target="_system"  class="default-button">
            <i class="mdi mdi-download"></i> Baixar PDF
        </download-link>
    </li>
</template>
<script>
import qs from 'query-string'
import { api_endpoint } from '~/plugins/api';
export default {
    props: ['arquivo', 'IdDocsprime'],
    computed: {
        condominio() {
            return this.$store.getters.condominio;
        },
        codigo_condominio() {
            if (!this.condominio) {
                return null;
            }
            return this.condominio.codigo;
        },
        jwt() {
            return this.$store.state.jwt;
        },
        url() {
            //let endpoint = `${location.origin}${location.pathname}api`;
            let endpoint = api_endpoint
            if (location.origin =='file://' || 'undefined' != typeof window.cordova) {                
                endpoint = window.api_endpoint;
            }   
            let url = `${endpoint}/condominios/${this.codigo_condominio}/conta-corrente/${this.IdDocsprime}/arquivo/${this.arquivo.id}/download?jwt=${this.jwt}`;
            //return `${endpoint}/docsprime/${this.id}/arquivos`;

            let query = qs.stringify({
                embedded: true,
                url
            });

            return `https://drive.google.com/viewerng/viewer?${query}`;
        }
    }
}
</script>